import apiClient from './apiClient';

export async function listSignals(filters = {}) {
  const res = await apiClient.get('/demand-sensing/signals', { params: filters });
  return res.data.data.items;
}

export async function refreshSignals() {
  const res = await apiClient.post('/demand-sensing/refresh');
  return res.data.data;
}
